import { collectorAuthHeaders, getCollectorToken } from "../helpers/collectorSession";
import { IdentityApiError, identityRequest, newIdentityKey } from "./physicalIdentityApi";
import { recoverCollectorSession } from "./collectorApi";

export type StockRow = { carrierId: string; batchId?: string; serial: string; serialNumber: number; carrierType: string; environment: string; manualCode: string; resolverPath: string; condition: string; allocationState: string };
export type StockInventory = { environment: string; holderType: string; holderId: string; total: number; page: number; counts: Record<string, number>; items: StockRow[] };
export type StockAllocation = { id: string; operation: string; fromHolderType: string; fromHolderId: string; toHolderType: string; toHolderId: string; carrierIds: string[]; reason: string; createdAt: string; createdBy: string };
export type StockHolder = { id: string; label: string };

export async function stockRequest<T>(collector: boolean, path: string, body?: unknown): Promise<T> {
  const root = "/stock" + (collector ? "/collector" : "");
  let key: string | undefined;
  const storageKey = "hkpStockPending:" + (collector ? "collector" : "staff");
  if (body !== undefined) {
    const fingerprint = JSON.stringify([(collector ? getCollectorToken() : localStorage.getItem("token"))?.slice(-16), path, body]);
    const previous = JSON.parse(sessionStorage.getItem(storageKey) || "null");
    key = previous?.fingerprint === fingerprint ? previous.key : newIdentityKey();
    sessionStorage.setItem(storageKey, JSON.stringify({ fingerprint, key }));
  }
  let result: T;
  if (!collector) result = await identityRequest<T>(root + path, body, key);
  else {
    const send = () => {
      const headers: Record<string, string> = { "Content-Type": "application/json", ...collectorAuthHeaders() };
      if (key) headers["Idempotency-Key"] = key;
      return fetch((process.env.REACT_APP_SERVERURL || "") + "/physical-identities" + root + path,
        { method: body === undefined ? "GET" : "POST", headers, cache: "no-store", body: body === undefined ? undefined : JSON.stringify(body) });
    };
    const sent = getCollectorToken();
    let res = await send();
    // An expired session renews once and the same request (same idempotency key) is sent again.
    if (res.status === 401 && (await recoverCollectorSession(sent))) res = await send();
    const payload = await res.json().catch(() => ({}));
    if (!res.ok || !payload.success) throw new IdentityApiError(payload.code || (res.status === 401 ? "SESSION_EXPIRED" : "REQUEST_FAILED"));
    result = payload.data;
  }
  if (body !== undefined) sessionStorage.removeItem(storageKey);
  return result;
}
